import React from 'react';
import renderHTML from 'react-render-html';
import { Button } from 'telstra-ui/components/button/Button';
import { stripStartingAndEndingPTags } from '../../../ssm-homepage/ssm-homepage.actions';

const SubmitSection = (props) => {
  const {
    authorableContent: {
      description,
      confirmButton,
      contactFieldDescription,
    },
    onSubmitSiteConfirmButton,
    submitLoader,
    digitalReadyBlankText,
    digitalReadyPreText,
  } = props;

  return (
    <React.Fragment>
      <div className="row submit-section">
        <div className="col-12 pl-sm-0 pr-sm-0 heading20">
          {contactFieldDescription}
        </div>
      </div>
      <div className="row">
        <div className="col-12 pl-sm-0 pr-sm-0">
          {renderHTML(stripStartingAndEndingPTags(description))}
        </div>
      </div>
      <div className="row">
        <div className="col-12 pl-sm-0 pr-sm-0">
          {renderHTML(digitalReadyBlankText)}
          <Button
            variant="secondary"
            size="medium"
            state="app"
            onClick={() => onSubmitSiteConfirmButton(false, true)}
          >{digitalReadyPreText}
          </Button>
        </div>
      </div>

      <div className="row">
        <div className="col-12 button-section pl-sm-0 pr-sm-0 paddingS text-center-mobile">
          <Button
            variant="super"
            onClick={() => onSubmitSiteConfirmButton(false)}
            state={submitLoader ? 'loading' : 'app'}
          >
            {confirmButton}
          </Button>
        </div>
      </div>
    </React.Fragment>
  );
};

export default SubmitSection;
